import { css } from "@emotion/react";

import { formatDate } from "~/lib/graphql/graphqlClient";
import { DatabaseDetailPageProps } from "~/pages/database/[id]";

const DatabaseMetaInfo = ({
  form,
}: {
  form: DatabaseDetailPageProps["form"];
}) => {
  return (
    <div css={rootStyle}>
      <p>Data: {form.responseSize}</p>
      <p>Created At: {formatDate(form.createdAt)}</p>
      <p>Managed By: {form.user.name}</p>
    </div>
  );
};

const rootStyle = css`
  border-top: 1px solid #ccc;
  padding: 0.75rem 1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #eee;
  color: #777;
  height: 2.5rem;
  width: 100%;
  & > p {
    margin: 0;
  }
`;

export default DatabaseMetaInfo;
